import { render, staticRenderFns } from "./SharingTabSidebar.vue?vue&type=template&id=43351179&scoped=true&"
import script from "./SharingTabSidebar.vue?vue&type=script&lang=js&"
export * from "./SharingTabSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SharingTabSidebar.vue?vue&type=style&index=0&id=43351179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43351179",
  null
  
)

export default component.exports